export default __webpack_public_path__ + "static/media/3.dfeea227.png";